// src/pages/PasswordChange.js

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { changePassword } from '../services/auth';
import PasswordInput from '../components/PasswordInput';
import './Login.css';

const PasswordChange = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { userid } = location.state || {}; // Retrieve the username passed from Login.js

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setError("Passwords don't match");
            return;
        }

        try {
            await changePassword({ userid, password, password_change_required:false });
            setSuccess(true);
            setTimeout(() => navigate('/login'), 3000); // Redirect to login after success
        } catch (err) {
            setError(err.response?.data?.detail || 'Failed to change password');
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="login-container">
                <div className="login-box">
                    <img src="/logo.png" alt="Goldfish Logo" className="login-logo" />
                    <h2 className="login-title">Your password need to be changed</h2>
                    <PasswordInput
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="New Password"
                        className="login-input"
                        required
                    />
                    <PasswordInput
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm Password"
                        className="login-input"
                        required
                    />
                    <p className="error">{error || '\u00A0'}</p>
                    <button type="submit" className="login-button">
                    Change Password
                    </button>
                </div>
            </div>
        </form>
    );
};

export default PasswordChange;
